<rt-dialog-header [heading]="title" [hasDivider]="true" [class.error]="danger" />
<rt-dialog-body layout>
  <p [innerHTML]="message"></p>
</rt-dialog-body>
@if (danger) {
  <rt-dialog-footer>
    <rt-button variant="plain" margin-right-small (click)="cancel()">
      <rt-truncate>{{ cancelLabel }}</rt-truncate>
    </rt-button>
    <rt-button variant="error" (click)="discardChanges()">
      <rt-truncate>{{ discardLabel }}</rt-truncate>
    </rt-button>
  </rt-dialog-footer>
} @else {
  <rt-dialog-footer [hasOptionalActions]="true">
    <rt-button variant="plain" class="optional danger-on-hover" (click)="discardChanges()">
      <rt-truncate>{{ discardLabel }}</rt-truncate>
    </rt-button>
    <rt-button variant="plain" (click)="cancel()">
      <rt-truncate>{{ cancelLabel }}</rt-truncate>
    </rt-button>
    @if (showSave) {
      <div [rtTooltip]="saveDisabled ? saveDisabledTooltip : null">
        <rt-button
          [disabled]="saveDisabled"
          variant="primary"
          [loading]="isLoading"
          (click)="saveChanges()"
        >
          <rt-truncate>{{ saveLabel }}</rt-truncate>
        </rt-button>
      </div>
    }
  </rt-dialog-footer>
}
